import React from "react";
import { createRoot } from "reactdom";
import App from "../components/PeopleBlock/App";

const renderPeopleBlock = () => {

	const peopleBlock = document.getElementsByClassName(
		"js-people-block"
	);
	if (!peopleBlock.length) return;

	Array.from(peopleBlock).forEach((card) => {
		const peopleBlockRoot = createRoot(card);
		peopleBlockRoot.render(<App {...card.dataset} />);
	});
};

export default renderPeopleBlock;
